var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-popover",
    {
      ref: "popover",
      staticClass: "time-tracking__customer__popover",
      on: { show: _vm.handleShow, hide: _vm.handleHide }
    },
    [
      _c(
        "div",
        { staticClass: "q-pa-md" },
        [
          _c("q-search", {
            staticClass: "time-tracking__customer__search",
            attrs: {
              "inverted-light": "",
              color: "blue-grey-1",
              debounce: _vm.defaultSearchDebounce
            },
            on: { input: _vm.handleSearch },
            model: {
              value: _vm.searchQuery,
              callback: function($$v) {
                _vm.searchQuery = $$v
              },
              expression: "searchQuery"
            }
          }),
          _c(
            "div",
            { staticClass: "time-tracking__customer__list q-mt-md" },
            [
              [
                _c(
                  "q-infinite-scroll",
                  {
                    ref: "infiniteScroll",
                    staticStyle: { height: "200px", overflow: "auto" },
                    attrs: { inline: "", handler: _vm.handleLoadMore }
                  },
                  [
                    _c("div", { staticClass: "q-mb-xs" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "time-tracking__customer hover-highlight q-py-xs q-px-sm row items-center cursor-pointer",
                          on: {
                            click: function($event) {
                              _vm.handleSelectCustomer(null)
                            }
                          }
                        },
                        [
                          _c("q-icon", {
                            staticClass: "invisible",
                            attrs: { name: "business" }
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "q-subheading text-italic text-faded on-right"
                            },
                            [_vm._v(_vm._s(_vm.$t("without_customer")))]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._l(_vm.customers, function(customer) {
                      return _c(
                        "div",
                        { key: customer.id, staticClass: "q-mb-xs" },
                        [
                          _c("customer-indicator", {
                            attrs: {
                              clickable: "",
                              customer: customer,
                              active: _vm.isActiveCustomer(customer)
                            },
                            on: {
                              click: function($event) {
                                _vm.handleSelectCustomer(customer)
                              }
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ],
              !_vm.hasCustomers
                ? [
                    _c(
                      "div",
                      { staticClass: "fit row justify-center items-center" },
                      [
                        _c("span", { staticClass: "text-faded" }, [
                          _vm._v(_vm._s(_vm.$t("no_customers")))
                        ])
                      ]
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }